module.exports = __webpack_public_path__ + "img/view.ef4c8f2e.svg";